import Api from "./axiosVersion1";

export const getAllTeams = async () => {
  return await Api.get(`/teams_with_users`);
};

export const getTeams = async () => {
  return await Api.get(`/teams`);
};

export const createTeam = async (data) => {
  return await Api.post(`/team`, data);
};

export const updateTeam = async ({ teamId, data }) => {
  return await Api.put(`/team/${teamId}`, data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

export const deleteTeam = async (teamId) => {
  return await Api.delete(`/team/${teamId}`);
};